import React from 'react';
import { ArrowUpRight, Check } from 'lucide-react';
import { ELITE_SERVICES } from '../mock';

const ServicesElite = () => {
  return (
    <section id="services" data-testid="services-elite-section" className="relative bg-white py-20 md:py-28 overflow-hidden">
      {/* Soft background accent */}
      <div className="absolute top-0 right-0 w-[40rem] h-[40rem] rounded-full bg-[#2AA8E8]/5 blur-3xl -translate-y-1/2 translate-x-1/3" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-14">
          <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#2AA8E8]">What we do</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0A1628] leading-[1.05]">
            Nationwide Vehicle <span className="text-[#2AA8E8]">Logistics</span> Solutions
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#4A5A72] leading-relaxed">
            Four purpose-built services. One disciplined operation. From single-unit retail shipments to recurring high-volume lanes, we deliver the same standard.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {ELITE_SERVICES.map((s, idx) => (
            <div
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className="group relative bg-white rounded-2xl border border-[#E5EAF2] overflow-hidden hover:border-[#0A1628] transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
            >
              {/* Image header */}
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/85 via-[#0A1628]/35 to-transparent" />
                <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#D4A24C] text-[#0A1628] text-[10px] font-bold uppercase tracking-widest">
                  {s.tag}
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="text-[11px] font-bold text-[#2AA8E8] uppercase tracking-widest mb-1">
                    0{idx + 1} · Service
                  </div>
                  <h3 className="text-2xl md:text-3xl font-extrabold text-white leading-tight">
                    {s.title}
                  </h3>
                </div>
              </div>

              {/* Body */}
              <div className="p-6 md:p-7">
                <p className="text-[#4A5A72] leading-relaxed mb-5 text-sm md:text-base">{s.copy}</p>
                <ul className="space-y-2 mb-5">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2 text-sm text-[#0A1628]">
                      <Check className="w-4 h-4 text-[#2AA8E8] mt-0.5 shrink-0" />
                      <span className="font-medium">{b}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="/#quote"
                  className="inline-flex items-center gap-1.5 text-sm font-bold text-[#0A1628] hover:text-[#2AA8E8] transition-colors"
                >
                  Get a quote for this service
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </div>

              {/* Gold accent line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#D4A24C] via-[#2AA8E8] to-[#D4A24C] opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesElite;
